import { scoreRating, summaryLabels } from './roundup';

const colours = { good: '#236b44', medium: '#f0b548', bad: '#b83a32' };

// Draw directly from saved data; the download works without sending a roundup
// or an account identifier to an image service.
export async function downloadRoundupImage({ number, items, stats, completed }) {
  const canvas = document.createElement('canvas');
  canvas.width = 1080;
  canvas.height = Math.max(1350, 770 + items.length * 84);
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Your browser cannot create this image.');
  ctx.fillStyle = '#f8f5ed'; ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = '#18261e'; ctx.fillRect(0, 0, 1080, 280);
  ctx.fillStyle = '#b4d897'; ctx.font = 'bold 27px Arial'; ctx.fillText('HAMMER THE BACKLOG', 70, 80);
  ctx.fillStyle = '#ffffff'; ctx.font = 'bold 76px Arial'; ctx.fillText(`Roundup ${number}`, 70, 180);
  ctx.font = '28px Arial'; ctx.fillText(completed ? 'A week of progress, saved.' : 'This week’s progress · Draft', 74, 238);

  summaryLabels.forEach(([key, label], index) => {
    const x = 70 + (index % 3) * 320;
    const y = 320 + Math.floor(index / 3) * 128;
    ctx.fillStyle = '#e3eadb'; ctx.fillRect(x, y, 300, 108);
    ctx.fillStyle = '#236b44'; ctx.font = 'bold 48px Arial'; ctx.fillText(String(stats[key] || 0), x + 22, y + 53);
    ctx.fillStyle = '#18261e'; ctx.font = '22px Arial'; ctx.fillText(label, x + 22, y + 85, 260);
  });

  ctx.fillStyle = '#18261e'; ctx.font = 'bold 28px Arial'; ctx.fillText('THE SCORECARD', 70, 625);
  if (!items.length) { ctx.font = '26px Arial'; ctx.fillText('Progress starts with showing up.', 70, 708); }
  items.forEach((item, index) => {
    const y = 660 + index * 84;
    const rating = scoreRating(item.value, item.aim);
    ctx.fillStyle = '#ffffff'; ctx.fillRect(70, y, 940, 72);
    ctx.fillStyle = colours[rating.className] || '#516152'; ctx.fillRect(70, y, 10, 72);
    ctx.fillStyle = '#18261e'; ctx.font = 'bold 25px Arial'; ctx.fillText(item.name, 102, y + 31, 620);
    ctx.font = '18px Arial'; ctx.fillText(rating.label, 102, y + 57);
    ctx.textAlign = 'right'; ctx.font = 'bold 29px Arial'; ctx.fillText(String(item.value ?? 0), 974, y + 32, 210);
    ctx.font = '18px Arial'; ctx.fillText(`Aim: ${item.aim ?? 0}`, 974, y + 57, 210); ctx.textAlign = 'left';
  });
  ctx.fillStyle = '#516152'; ctx.font = '24px Arial'; ctx.fillText('One week at a time. Hammer your backlog.', 70, canvas.height - 58);
  const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/png'));
  if (!blob) throw new Error('Unable to create the image. Please try again.');
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a'); link.href = url; link.download = `hammer-the-backlog-roundup-${number}.png`;
  document.body.appendChild(link); link.click(); link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
